export default "__VITE_ASSET__NopH1PwQ__"